<h2>Crear Orden de servicio</h2>

<div class="container">
<form [formGroup]="ordenForm" (ngSubmit)="guardarOrden()">

<!-- SECCIÓN CABECERO -->
<h3>Cabecero de Orden</h3>

<!-- Fila con 4 campos -->
<div class="row mb-3">
  <div class="col-md-2">
    <label for="addressNumber" class="form-label">Address Number</label>
    <input type="text" class="form-control" id="addressNumber" formControlName="addressNumber">
  </div>
  <div class="col-md-2">
    <label for="orderNumber" class="form-label">Número de Orden</label>
    <input type="number" class="form-control" id="orderNumber" formControlName="orderNumber">
  </div>
  <div class="col-md-2">
    <label for="orderAmount" class="form-label">Monto de Orden</label>
    <input type="number" class="form-control" id="orderAmount" formControlName="orderAmount">
  </div>
  <div class="col-md-2">
    <label for="currencyCode" class="form-label">Currency Code</label>
    <input type="text" class="form-control" id="currencyCode" formControlName="currencyCode">
  </div>

  <div class="col-md-2">
    <label for="businessUnit" class="form-label">Business Unit</label>
    <input type="text" class="form-control" id="businessUnit" formControlName="businessUnit">
  </div>
</div>

<!-- Fila con 5 campos -->
<div class="row mb-3">

  <div class="col-md-2">
    <label for="companyKey" class="form-label">Company Key</label>
    <input type="text" class="form-control" id="companyKey" formControlName="companyKey">
  </div>
  <div class="col-md-2">
    <label for="exchangeRate" class="form-label">Exchange Rate</label>
    <input type="number" class="form-control" id="exchangeRate" formControlName="exchangeRate">
  </div>
  <div class="col-md-2">
    <label for="dateRequested" class="form-label">Fecha Solicitud</label>
    <input type="date" class="form-control" id="dateRequested" formControlName="dateRequested">
  </div>
  <div class="col-md-2">
    <label for="dateEnd" class="form-label">Fecha Fin</label>
    <input type="date" class="form-control" id="dateEnd" formControlName="dateEnd">
  </div>

  <div class="col-md-2">
    <label for="tecnicoAsignado" class="form-label">Técnico Asignado</label>
    <input type="text" class="form-control" id="tecnicoAsignado" formControlName="tecnicoAsignado">
  </div>
</div>

<!-- Fila con 3 campos -->
<div class="row mb-3">

  <div class="col-md-4">
    <label for="orderStatus" class="form-label">Estado de Orden</label>
    <input type="text" class="form-control" id="orderStatus" formControlName="orderStatus">
  </div>
  <div class="col-md-4">
    <label for="shortCompanyName" class="form-label">Nombre Corto Empresa</label>
    <input type="text" class="form-control" id="shortCompanyName" formControlName="shortCompanyName">
  </div>
  <div class="col-md-4">
    <label for="email" class="form-label">Email</label>
    <input type="email" class="form-control" id="email" formControlName="email">
  </div>
</div>

<!-- Fila con campo grande (email) -->
<!-- <div class="row mb-3">
</div> -->

<!-- Fila con campo grande (descripción) -->
<div class="row mb-3">
  <div class="col-md-12">
    <label for="description" class="form-label">Descripción</label>
    <textarea class="form-control" id="description" formControlName="description" rows="3"></textarea>
  </div>
</div>


<hr>

<!-- SECCIÓN DETALLE -->
<h3>Detalles (Productos)</h3>
<div formArrayName="detalles">

  <table class="table table-bordered table-sm">
    <thead class="table-light">
      <tr>
        <th>#</th>
<!--         <th>id</th> -->
        <th>accountId</th>
        <th>altItemNumber</th>
        <th>amount</th>
        <th>amountReceived</th>

        <th>codigoSat</th> 
        <th>currency</th> 
        <th>currencyCode</th> 
        <th>exchangeRate</th> 
        <th>extendedPrice</th> 
        <th>foreignAmount</th> 
        <th>glOffSet</th> 
		
		    <th>itemDescription</th> 
        <th>quantity</th> 
		    <th>unitCost</th> 
     
        <th>lineNumber</th> 
        <th>lineStatus</th> 
        <th>lineType</th> 
        <th>location</th> 
        <th>lotExpirationDate</th> 
        <th>lotNumber</th> 
        <th>notes</th> 
        <th>objectAccount</th> 
        <th>openAmount</th> 
        <th>orderCompany</th> 
        <th>orderNumber</th> 
        <th>orderType</th> 
        <th>pending</th> 
        <th>reason</th> 
        <th>receiptType</th> 
        <th>received</th> 
        <th>receptionBy</th> 
        <th>receptionDate</th> 
        <th>rejected</th> 
        <th>status</th> 
        <th>taxCode</th> 
        <th>taxable</th> 
        <th>toReceive</th> 
        <th>toReject</th> 
        <th>transferDate</th> 
        <th>transferStatus</th> 
        <th>uom</th> 

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let detalle of detalles.controls; let i = index" [formGroupName]="i">
        <td>{{ i + 1 }}</td>
<!--         <td><input type="text" class="form-control" id="id" formControlName="id" name="id"></td>
 -->        
        <td><input type="text" class="form-control" id="accountId" formControlName="accountId" name="accountId"></td>
        <td><input type="text" class="form-control" id="altItemNumber" formControlName="altItemNumber" name="altItemNumber"></td>
        <td><input type="text" class="form-control" id="amount" formControlName="amount" name="amount"></td>
        <td><input type="text" class="form-control" id="amountReceived" formControlName="amountReceived" name="amountReceived"></td>
        <td><input type="text" class="form-control" id="codigoSat" formControlName="codigoSat" name="codigoSat"></td>
        <td><input type="text" class="form-control" id="currency" formControlName="currency" name="currency"></td>
        <td><input type="text" class="form-control" id="currencyCode" formControlName="currencyCode" name="currencyCode"></td>
        <td><input type="text" class="form-control" id="exchangeRate" formControlName="exchangeRate" name="exchangeRate"></td>
        <td><input type="text" class="form-control" id="extendedPrice" formControlName="extendedPrice" name="extendedPrice"></td>
        <td><input type="text" class="form-control" id="foreignAmount" formControlName="foreignAmount" name="foreignAmount"></td>
        <td><input type="text" class="form-control" id="glOffSet" formControlName="glOffSet" name="glOffSet"></td>
      
        <td><input type="text" class="form-control"
              id="itemDescription"
              formControlName="itemDescription"
              [ngClass]="{'is-invalid': detalle.get('itemDescription')?.invalid && detalle.get('itemDescription')?.touched}">
        <div *ngIf="detalle.get('itemDescription')?.invalid && detalle.get('itemDescription')?.touched" class="text-danger">
          La descripción es obligatoria
        </div></td>

        <td><input type="number" class="form-control"
              id="quantity"
              formControlName="quantity"
              [ngClass]="{'is-invalid': detalle.get('quantity')?.invalid && detalle.get('quantity')?.touched}">
        <div *ngIf="detalle.get('quantity')?.invalid && detalle.get('quantity')?.touched" class="text-danger">
          La cantidad es obligatoria
        </div></td>
      
        <td><input type="number" class="form-control"
              id="unitCost"
              formControlName="unitCost"
              [ngClass]="{'is-invalid': detalle.get('unitCost')?.invalid && detalle.get('unitCost')?.touched}">
        <div *ngIf="detalle.get('unitCost')?.invalid && detalle.get('unitCost')?.touched" class="text-danger">
          El costo unitario es obligatorio
        </div></td>
      
        <td><input type="text" class="form-control" id="lineNumber" formControlName="lineNumber" name="lineNumber"></td>
        <td><input type="text" class="form-control" id="lineStatus" formControlName="lineStatus" name="lineStatus"></td>
        <td><input type="text" class="form-control" id="lineType" formControlName="lineType" name="lineType"></td>
        <td><input type="text" class="form-control" id="location" formControlName="location" name="location"></td>
        <td><input type="text" class="form-control" id="lotExpirationDate" formControlName="lotExpirationDate" name="lotExpirationDate"></td>
        <td><input type="text" class="form-control" id="lotNumber" formControlName="lotNumber" name="lotNumber"></td>
        <td><input type="text" class="form-control" id="notes" formControlName="notes" name="notes"></td>
        <td><input type="text" class="form-control" id="objectAccount" formControlName="objectAccount" name="objectAccount"></td>
        <td><input type="text" class="form-control" id="openAmount" formControlName="openAmount" name="openAmount"></td>
        <td><input type="text" class="form-control" id="orderCompany" formControlName="orderCompany" name="orderCompany"></td>
        <td><input type="text" class="form-control" id="orderNumber" formControlName="orderNumber" name="orderNumber"></td>
        <td><input type="text" class="form-control" id="orderType" formControlName="orderType" name="orderType"></td>
        <td><input type="text" class="form-control" id="pending" formControlName="pending" name="pending"></td>
        <td><input type="text" class="form-control" id="reason" formControlName="reason" name="reason"></td>
        <td><input type="text" class="form-control" id="receiptType" formControlName="receiptType" name="receiptType"></td>
        <td><input type="text" class="form-control" id="received" formControlName="received" name="received"></td>
        <td><input type="text" class="form-control" id="receptionBy" formControlName="receptionBy" name="receptionBy"></td>
        <td><input type="text" class="form-control" id="receptionDate" formControlName="receptionDate" name="receptionDate"></td>
        <td><input type="text" class="form-control" id="rejected" formControlName="rejected" name="rejected"></td>
        <td><input type="text" class="form-control" id="status" formControlName="status" name="status"></td>
        <td><input type="text" class="form-control" id="taxCode" formControlName="taxCode" name="taxCode"></td>
        <td><input type="text" class="form-control" id="taxable" formControlName="taxable" name="taxable"></td>
        <td><input type="text" class="form-control" id="toReceive" formControlName="toReceive" name="toReceive"></td>
        <td><input type="text" class="form-control" id="toReject" formControlName="toReject" name="toReject"></td>
        <td><input type="text" class="form-control" id="transferDate" formControlName="transferDate" name="transferDate"></td>
        <td><input type="text" class="form-control" id="transferStatus" formControlName="transferStatus" name="transferStatus"></td>
        <td><input type="text" class="form-control" id="uom" formControlName="uom" name="uom"></td>
      
        <td>
          <button type="button" class="btn btn-danger btn-sm" (click)="removerLinea(i)">Eliminar</button>
        </td>
      
      </tr>
    </tbody>
  </table>

<!--   <div *ngFor="let detalle of detalles.controls; let i = index" [formGroupName]="i" style="margin-bottom: 10px;">     
 -->    <!-- <span>Detalle #{{i + 1}}</span> -->

<!-- 
    <div class="mb-3">  <label for="id" class="form-label">id</label><input type="text" class="form-control" id="id" formControlName="id" name="id"></div>
    <div class="mb-3">  <label for="accountId" class="form-label">accountId</label><input type="text" class="form-control" id="accountId" formControlName="accountId" name="accountId"></div>
    <div class="mb-3">  <label for="altItemNumber" class="form-label">altItemNumber</label><input type="text" class="form-control" id="altItemNumber" formControlName="altItemNumber" name="altItemNumber"></div>
    <div class="mb-3">  <label for="amount" class="form-label">amount</label><input type="text" class="form-control" id="amount" formControlName="amount" name="amount"></div>
    <div class="mb-3">  <label for="amountReceived" class="form-label">amountReceived</label><input type="text" class="form-control" id="amountReceived" formControlName="amountReceived" name="amountReceived"></div>
    <div class="mb-3">  <label for="codigoSat" class="form-label">codigoSat</label><input type="text" class="form-control" id="codigoSat" formControlName="codigoSat" name="codigoSat"></div>
    <div class="mb-3">  <label for="currency" class="form-label">currency</label><input type="text" class="form-control" id="currency" formControlName="currency" name="currency"></div>
    <div class="mb-3">  <label for="currencyCode" class="form-label">currencyCode</label><input type="text" class="form-control" id="currencyCode" formControlName="currencyCode" name="currencyCode"></div>
    <div class="mb-3">  <label for="exchangeRate" class="form-label">exchangeRate</label><input type="text" class="form-control" id="exchangeRate" formControlName="exchangeRate" name="exchangeRate"></div>
    <div class="mb-3">  <label for="extendedPrice" class="form-label">extendedPrice</label><input type="text" class="form-control" id="extendedPrice" formControlName="extendedPrice" name="extendedPrice"></div>
    <div class="mb-3">  <label for="foreignAmount" class="form-label">foreignAmount</label><input type="text" class="form-control" id="foreignAmount" formControlName="foreignAmount" name="foreignAmount"></div>
    <div class="mb-3">  <label for="glOffSet" class="form-label">glOffSet</label><input type="text" class="form-control" id="glOffSet" formControlName="glOffSet" name="glOffSet"></div>
    <div class="mb-3">  <label for="itemDescription" class="form-label">itemDescription</label><input type="text" class="form-control" id="itemDescription" formControlName="itemDescription" name="itemDescription"></div>
    
        <div class="mb-3">
      <label for="itemDescription" class="form-label">Descripción del producto</label>
      <input type="text" class="form-control"
             id="itemDescription"
             formControlName="itemDescription"
             [ngClass]="{'is-invalid': detalle.get('itemDescription')?.invalid && detalle.get('itemDescription')?.touched}">
      <div *ngIf="detalle.get('itemDescription')?.invalid && detalle.get('itemDescription')?.touched" class="text-danger">
        La descripción es obligatoria
      </div>
    </div>

    <div class="mb-3">
      <label for="quantity" class="form-label">Cantidad</label>
      <input type="number" class="form-control"
             id="quantity"
             formControlName="quantity"
             [ngClass]="{'is-invalid': detalle.get('quantity')?.invalid && detalle.get('quantity')?.touched}">
      <div *ngIf="detalle.get('quantity')?.invalid && detalle.get('quantity')?.touched" class="text-danger">
        La cantidad es obligatoria
      </div>
    </div>

    <div class="mb-3">
      <label for="unitCost" class="form-label">Costo unitario</label>
      <input type="number" class="form-control"
             id="unitCost"
             formControlName="unitCost"
             [ngClass]="{'is-invalid': detalle.get('unitCost')?.invalid && detalle.get('unitCost')?.touched}">
      <div *ngIf="detalle.get('unitCost')?.invalid && detalle.get('unitCost')?.touched" class="text-danger">
        El costo unitario es obligatorio
      </div>
    </div>
    
    <div class="mb-3">  <label for="itemNumber" class="form-label">itemNumber</label><input type="text" class="form-control" id="itemNumber" formControlName="itemNumber" name="itemNumber"></div>
    <div class="mb-3">  <label for="lineNumber" class="form-label">lineNumber</label><input type="text" class="form-control" id="lineNumber" formControlName="lineNumber" name="lineNumber"></div>
    <div class="mb-3">  <label for="lineStatus" class="form-label">lineStatus</label><input type="text" class="form-control" id="lineStatus" formControlName="lineStatus" name="lineStatus"></div>
    <div class="mb-3">  <label for="lineType" class="form-label">lineType</label><input type="text" class="form-control" id="lineType" formControlName="lineType" name="lineType"></div>
    <div class="mb-3">  <label for="location" class="form-label">location</label><input type="text" class="form-control" id="location" formControlName="location" name="location"></div>
    <div class="mb-3">  <label for="lotExpirationDate" class="form-label">lotExpirationDate</label><input type="text" class="form-control" id="lotExpirationDate" formControlName="lotExpirationDate" name="lotExpirationDate"></div>
    <div class="mb-3">  <label for="lotNumber" class="form-label">lotNumber</label><input type="text" class="form-control" id="lotNumber" formControlName="lotNumber" name="lotNumber"></div>
    <div class="mb-3">  <label for="notes" class="form-label">notes</label><input type="text" class="form-control" id="notes" formControlName="notes" name="notes"></div>
    <div class="mb-3">  <label for="objectAccount" class="form-label">objectAccount</label><input type="text" class="form-control" id="objectAccount" formControlName="objectAccount" name="objectAccount"></div>
    <div class="mb-3">  <label for="openAmount" class="form-label">openAmount</label><input type="text" class="form-control" id="openAmount" formControlName="openAmount" name="openAmount"></div>
    <div class="mb-3">  <label for="orderCompany" class="form-label">orderCompany</label><input type="text" class="form-control" id="orderCompany" formControlName="orderCompany" name="orderCompany"></div>
    <div class="mb-3">  <label for="orderNumber" class="form-label">orderNumber</label><input type="text" class="form-control" id="orderNumber" formControlName="orderNumber" name="orderNumber"></div>
    <div class="mb-3">  <label for="orderType" class="form-label">orderType</label><input type="text" class="form-control" id="orderType" formControlName="orderType" name="orderType"></div>
    <div class="mb-3">  <label for="pending" class="form-label">pending</label><input type="text" class="form-control" id="pending" formControlName="pending" name="pending"></div>
     <div class="mb-3">  <label for="quantity" class="form-label">quantity</label><input type="text" class="form-control" id="quantity" formControlName="quantity" name="quantity"></div>
     <div class="mb-3">  <label for="reason" class="form-label">reason</label><input type="text" class="form-control" id="reason" formControlName="reason" name="reason"></div>
    <div class="mb-3">  <label for="receiptType" class="form-label">receiptType</label><input type="text" class="form-control" id="receiptType" formControlName="receiptType" name="receiptType"></div>
    <div class="mb-3">  <label for="received" class="form-label">received</label><input type="text" class="form-control" id="received" formControlName="received" name="received"></div>
    <div class="mb-3">  <label for="receptionBy" class="form-label">receptionBy</label><input type="text" class="form-control" id="receptionBy" formControlName="receptionBy" name="receptionBy"></div>
    <div class="mb-3">  <label for="receptionDate" class="form-label">receptionDate</label><input type="text" class="form-control" id="receptionDate" formControlName="receptionDate" name="receptionDate"></div>
    <div class="mb-3">  <label for="rejected" class="form-label">rejected</label><input type="text" class="form-control" id="rejected" formControlName="rejected" name="rejected"></div>
    <div class="mb-3">  <label for="status" class="form-label">status</label><input type="text" class="form-control" id="status" formControlName="status" name="status"></div>
    <div class="mb-3">  <label for="taxCode" class="form-label">taxCode</label><input type="text" class="form-control" id="taxCode" formControlName="taxCode" name="taxCode"></div>
    <div class="mb-3">  <label for="taxable" class="form-label">taxable</label><input type="text" class="form-control" id="taxable" formControlName="taxable" name="taxable"></div>
    <div class="mb-3">  <label for="toReceive" class="form-label">toReceive</label><input type="text" class="form-control" id="toReceive" formControlName="toReceive" name="toReceive"></div>
    <div class="mb-3">  <label for="toReject" class="form-label">toReject</label><input type="text" class="form-control" id="toReject" formControlName="toReject" name="toReject"></div>
    <div class="mb-3">  <label for="transferDate" class="form-label">transferDate</label><input type="text" class="form-control" id="transferDate" formControlName="transferDate" name="transferDate"></div>
    <div class="mb-3">  <label for="transferStatus" class="form-label">transferStatus</label><input type="text" class="form-control" id="transferStatus" formControlName="transferStatus" name="transferStatus"></div>
     <div class="mb-3">  <label for="unitCost" class="form-label">unitCost</label><input type="text" class="form-control" id="unitCost" formControlName="unitCost" name="unitCost"></div>
     <div class="mb-3">  <label for="uom" class="form-label">uom</label><input type="text" class="form-control" id="uom" formControlName="uom" name="uom"></div>
 -->
<!--     <button type="button" (click)="removerLinea(i)" *ngIf="detalles.length > 1">
      Eliminar
    </button> -->
  
</div>

<!-- <button type="button" (click)="agregarLinea()">+ Agregar Producto</button>
 -->

<button type="button" class="btn btn-secondary" (click)="agregarLinea()">+ Agregar Producto</button>
<br><br>
<button type="submit" [disabled]="ordenForm.invalid" [style.opacity]="ordenForm.invalid ? '0.5' : '1'" style="background-color: green; color: white;">
  Guardar Orden Completa
</button>

  <!-- <button type="submit" class="btn btn-primary" (click)="addServiceOrder()" >Crear</button> -->

</form>

</div>